import OpenCollections from './OpenCollections';

export default OpenCollections;
